import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import disenoAmebr from './img/diseno-amebr.png'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization(); const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = 'Occurrió un error.';

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-americabr-container" id="bodyam" ref={nodeRef}>
        <img src={disenoAmebr} alt="logo" className="logo-americabr" id="logo-americabr" />
        <Form onSubmit={(event) => onSubmit(event)} className="formamericabr">
          <Row className="login-americabr-header">
            <Col>
              <h1>Login</h1>
            </Col>
          </Row>
          <Row className="login-americabr-body">
            <Col>
              <div className="americabr-container-input">
                <label>{translate("CPF")}</label>
                <Input
                  className="user-input-americabr"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  placeholder="000.000.000-00"
                  onChange={e => setUsername(e.target.value)}
                />
              </div>
              <div className="americabr-container-input">
                <label>{translate("Senha")}</label>
                <Input
                  className="pass-input-americabr"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeholder="*****"
                  onChange={e => setPassword(e.target.value)}
                />
              </div>
              {!onLogin ? (
                <div className="container-button-americabr">
                  <button
                    block={!parameters.failureRedirect}
                    tabIndex={1}
                    type="submit"
                    id="submmit"
                    className="enter-americabr"
                    disabled={!props.turnstileSuccess}
                  >
                    {translate("ButtonEnter")}
                  </button>
                </div>
              ) : (
                <div className="container-progress-bar-americabr" style={{ marginTop: 20 }}>
                  <Progress animated color="danger" value={100} className="americabr-progress-bar" />
                </div>
              )}
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
              <div className="recover-password-americabr">
                <p>{translate("ContactMessage")}</p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
              <div className="register-account-americabr">
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
